(function () {
  function props(el){ return {
    quiz_cta_source: el.getAttribute('data-quiz-cta-source') || 'unattributed',
    quiz_source: el.getAttribute('data-quiz-source') || '',
    quiz_cta_destination: el.getAttribute('data-quiz-cta-destination') || el.getAttribute('href') || '',
    quiz_cta_label: el.getAttribute('data-quiz-cta-label') || (el.textContent||'').trim().slice(0,80),
    quiz_cta_style: el.getAttribute('data-quiz-cta-style') || 'inline'
  }; }
  function fire(name, ph, p){
    if (window.posthog && window.posthog.capture) window.posthog.capture(ph, p);
    if (typeof fbq === 'function') fbq('trackCustom', name, p);
    if (typeof gtag === 'function') gtag('event', ph, p);
  }
  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest ? e.target.closest('[data-quiz-cta]') : null;
    if (el) fire('QuizCTAClicked', 'quiz_cta_clicked', props(el));
  }, true);
  if ('IntersectionObserver' in window) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function(es){ es.forEach(function(en){
      if (en.isIntersecting && !seen.has(en.target)) { seen.add(en.target);
        fire('QuizCTAViewed','quiz_cta_viewed', props(en.target)); io.unobserve(en.target); } }); }, { threshold:0.5 });
    var bind = function(){ document.querySelectorAll('[data-quiz-cta]').forEach(function(el){ io.observe(el); }); };
    (document.readyState==='loading') ? document.addEventListener('DOMContentLoaded', bind) : bind();
  }
})();
